import { AuthenticationLocalService } from "../../features/authentication/data/data_source/local/authentication_local_service";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import LanguageSelector from "../../core/components/language_selector";
import { useTranslation } from "../../i18n/useTranslation";
import { setLanguage } from "../../i18n/config";

interface PublicRouteProps {
    homeLocation: string;
}

function PublicRoute({ homeLocation}: PublicRouteProps) {
    const token = new AuthenticationLocalService().getAccessToken();
    const location = useLocation();
    const { i18n } = useTranslation();

    useEffect(() => {
        if (token != null) return;
        document.body.classList.add('auth-background');

        const meta = document.querySelector('meta[name="theme-color"]');
        const prevThemeColor = meta?.getAttribute('content') ?? null;
        meta?.setAttribute('content', '#FFFFFF');

        return () => {
            document.body.classList.remove('auth-background');
            if (prevThemeColor !== null) meta?.setAttribute('content', prevThemeColor);
        };
    }, [token]);

    return token == null
        ? <>
            <div className="fixed top-4 right-4 z-50">
                <LanguageSelector value={i18n.resolvedLanguage ?? i18n.language} onChange={setLanguage} className="text-sm py-1.5! px-3! shadow-sm"/>
            </div>
            <Outlet/>
          </>
        : <Navigate to={homeLocation} state={{ from: location }} replace />;
}

export default PublicRoute;